import React from "react";

const SnowWhiteFacialCustomer = () => {
  return (
    <div className="organicFacialCustomerContainer">
      <h5>
        Testimonials: What Our Clients Say About Our Organic Facial Services in
        Bangalore
      </h5>
      <p>
        Don’t just take our word for it; hear what our clients have to say about
        our{" "}
        <a href="https://scentlifestyle.com/organic-facial-services">
          organic facial services in Bangalore
        </a>
        :
      </p>
      <div className="organicFacialCustomerContent">
        <p>
          <span className="quote">“</span>The Snow White Facial at SCENT is
          incredible. My skin has never looked or felt better{" "}
          <span className="quote">”</span> - <span>Ananya s. </span>
        </p>
        <p>
          <span className="quote">“</span> SCENT’s Snow White Facial Services in
          Bangalore are a game-changer. I love the natural ingredients and the
          luxurious experience. <span className="quote">”</span> -{" "}
          <span>Rhea M. </span>
        </p>
        <p>
          <span className="quote">“</span> The personalized approach at SCENT
          makes all the difference. Their Snow White Facials have transformed my
          skin, and I always look forward to my appointments.{" "}
          <span className="quote">”</span> - <span>Priya K. </span>
        </p>
      </div>
    </div>
  );
};

export default SnowWhiteFacialCustomer;
